const routes = [
    {
        path: "/program/change/request/form",
        component: () => import("../pages/RequestForm.vue"),
        meta: {
            isAuthenticated: true,
        }
    },
];

export default routes;
